import request from '@/plugins/axios'
import systemConfig from '@/plugins/requireConfig/systemConfig.js'

export function getSubscribePage(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/industrialinjurySubscribe/gl/v1.0.0/page`,
        method: 'post',
        data
    })
}

export function addSubscribe(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/industrialinjurySubscribe/gl/v1.0.0/add`,
        method: 'post',
        data
    })
}

export function updateSubscribe(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/industrialinjurySubscribe/gl/v1.0.0/update`,
        method: 'post',
        data
    })
}

export function deleteSubscribe(id) {
    return request({
        url: `/${systemConfig.businessPrefix}/industrialinjurySubscribe/gl/v1.0.0/delete`,
        method: 'post',
        data: { id }
    })
}

export function getSubscribeTemplate() {
    return request({
        url: `/${systemConfig.businessPrefix}/industrialinjurySubscribe/gl/v1.0.0/excelTemplateGain`,
        method: 'post',
        responseType: 'blob'
    })
}

export function importSubscribe(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/industrialinjurySubscribe/gl/v1.0.0/subscribeImport`,
        method: 'post',
        data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}
